import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=8f3075e2&scoped=true"
import script from "./banner.vue?vue&type=script&lang=ts"
export * from "./banner.vue?vue&type=script&lang=ts"
import style0 from "./banner.vue?vue&type=style&index=0&id=8f3075e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3075e2",
  null
  
)

export default component.exports